module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.merchList) ? _c('div', _vm._l((_vm.merchList), function(merch) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v(_vm._s(merch.merchandiseLabel))]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "list-block media-list"
    }, [_c('ul', [_c('li', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('img', {
      attrs: {
        "src": _vm.baseurl + merch.merchandiseIcon,
        "width": "44"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticStyle: {
        "border": "#2ac845",
        "padding-bottom": ".5rem"
      }
    }, [_vm._l((merch._subTitleList), function(subTitle) {
      return (merch._subTitleList && merch._subTitleList.length > 0) ? _c('span', [_c('span', {
        staticStyle: {
          "position": "relative",
          "color": "white",
          "background-color": "white",
          "padding": "0.1rem"
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": ".7rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((merch._abstractList), function(abstractTitle) {
      return (merch._abstractList && merch._abstractList.length > 0) ? _c('span', {
        staticStyle: {
          "font-size": ".7rem",
          "color": "black"
        }
      }, [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))])]) : _vm._e()
    })], 2), _vm._v(" "), _vm._l((merch._titleList), function(title) {
      return (merch._titleList && merch._titleList.length > 0) ? _c('span', {
        staticStyle: {
          "left": "0",
          "bottom": "0",
          "font-size": "1rem",
          "color": "#3F3F3F",
          "padding": "0.2rem 0 0.2rem 0",
          "font-weight": "bold"
        }
      }, [(title.valueText !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()]) : _vm._e()
    })], 2)])])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.response(merch)
        }
      }
    }, [_vm._v(_vm._s(_vm.buttonName2))]), _vm._v(" "), _c('span', {
      staticClass: "goToComment",
      staticStyle: {
        "color": "#0a8ddf"
      },
      on: {
        "click": function($event) {
          return _vm.goToComment(merch)
        }
      }
    }, [_vm._v(_vm._s(_vm.buttonName1))])])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ff354a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MyOrder/comment/child/MyCommentOrder.vue
// module id = 1563
// module chunks = 8